(function () {
  function init(scope) {
    (scope || document).querySelectorAll('[data-payment-auto]').forEach(function (row) {
      if (row.dataset.paymentReady) return;
      var form = row.closest('form');
      if (!form) return;
      row.dataset.paymentReady = 'true';
      function sync() {
        var input = form.querySelector('[name="selling_plan"]:not([disabled])');
        if (input && (input.type === 'radio' || input.type === 'checkbox')) input = form.querySelector('[name="selling_plan"]:checked:not([disabled])');
        row.dataset.subscription = String(Boolean(input && input.value));
      }
      form.addEventListener('change', sync);
      form.addEventListener('input', sync);
      form.addEventListener('click', function () { requestAnimationFrame(sync); });
      new MutationObserver(sync).observe(form, {childList:true,subtree:true,attributes:true,attributeFilter:['value','disabled','checked']});
      sync();
    });
  }
  if (window.mwPaymentMethodsInit) { window.mwPaymentMethodsInit(); return; }
  window.mwPaymentMethodsInit = init;
  init();
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
}());
